// /plugins/pip.client.ts
export default defineNuxtPlugin(() => {
  return {
    provide: {
      enterPiP: async (video: HTMLVideoElement) => {
        if (document.pictureInPictureEnabled && !video.disablePictureInPicture) {
          try {
            await video.requestPictureInPicture()
          } catch (err) {
            console.error("PiP starten fehlgeschlagen:", err)
          }
        }
      },
      exitPiP: async () => {
        if (document.pictureInPictureElement) {
          try {
            await document.exitPictureInPicture()
          } catch (err) {
            console.error("PiP beenden fehlgeschlagen:", err)
          }
        }
      }
    }
  }
})
